import fetchApi from "../apiHelper";

const API_BASE_URL=process.env.REACT_APP_API_BASE_URL

// Load stations (cdip and noaa)
async function httpGetStations() {

    const response = await fetchApi(`${API_BASE_URL}/stations/`);
  
    return await response.json();
  }
  
  
export {
    httpGetStations,
  };